/**
 * De onde a tela Expedição tira os dados: só do serviço `services/expedicao` (loopback 8110, nginx com
 * sessão do BI). O navegador nunca manda X-Token: o nginx injeta nos POST.
 */
import type { DadosExpedicao, Ontem, Pedido } from './types'

const API = '/api/expedicao'

async function ler<T>(caminho: string): Promise<T> {
  const res = await fetch(`${API}${caminho}`, { credentials: 'include', cache: 'no-store' })
  if (!res.ok) throw new Error(`http ${res.status}`)
  return (await res.json()) as T
}

export const carregar = (): Promise<DadosExpedicao> => ler<DadosExpedicao>('/dados')

export async function carregarEmbalados(dia: string): Promise<Pedido[]> {
  const j = await ler<{ dia: string; pedidos: Pedido[] }>(`/embalados?dia=${encodeURIComponent(dia)}`)
  return j.pedidos
}

/** Conjunto do "% embalado no prazo" do último dia útil (pedidos com prazo nesse dia, embalados ou não). */
export const carregarOntem = (): Promise<Ontem & { pedidos: Pedido[] }> => ler<Ontem & { pedidos: Pedido[] }>('/ontem')

export async function salvarNome(embalador_id: string, nome: string): Promise<void> {
  const res = await fetch(`${API}/usuarios`, {
    method: 'POST', credentials: 'include', cache: 'no-store',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ embalador_id, nome }),
  })
  if (!res.ok) {
    const j = (await res.json().catch(() => ({}))) as { detail?: string }
    throw new Error(j.detail || `http ${res.status}`)
  }
}

/** Pede um ciclo agora (o serviço roda em segundo plano; a tela recarrega depois). */
export async function pedirAtualizacao(): Promise<void> {
  const res = await fetch(`${API}/atualizar`, { method: 'POST', credentials: 'include', cache: 'no-store' })
  if (!res.ok) throw new Error(`http ${res.status}`)
}

/** Link da TV com a chave; só sai do serviço para quem passou pelo login do BI. null = chave não configurada. */
export async function carregarLinkTv(): Promise<string | null> {
  const res = await fetch(`${API}/tv-link`, { credentials: 'include', cache: 'no-store' })
  if (res.status === 404) return null
  if (!res.ok) throw new Error(`http ${res.status}`)
  return ((await res.json()) as { url: string }).url
}
